export const LOCALES = [
  { name: 'English', code: 'en' },
  { name: 'Français', code: 'fr' },
  { name: 'Italiano', code: 'it' },
  { name: 'Deutsch', code: 'de' },
  { name: 'Español', code: 'es' },
  { name: 'Nederlands', code: 'nl' },
];
